module.exports = __webpack_public_path__ + "img/Butterfly_00297.e54f2446.png";